
import IndexModelTable from "@/views/paginas/sigap/modelos/IndexModelTable.vue";
import CardRh from "@/components/cards/ManzaCard.vue";
import DisciplinaService from "@/service/v1/sigap/DisciplinaService";
import { Options } from "vue-class-component";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";

@Options({
    name: "DisciplinaIndex",
    components: { CardRh, KDataTable, Multiselect },
})
export default class DisciplinaIndex extends IndexModelTable {
    public tipo_id: any = null;
    public tipos: any = null;
    public status_id: any = null;
    public status: any = null;
    public turma = ""; 
    public cpfInstrutor = "";
    public cargaHorariaMin: any = null;
    public cargaHorariaMax: any = null;
    public isSomatorio: any = null;
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get tipos_select() {
        if (this.tipos) {
            return this.tipos.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    get somatorio_select() {
        return [
            { value: "true", label: "Sim" },
            { value: "false", label: "Nao" },
        ];
    }

    public getDisciplinaTipo() {
        this.processando = true;
        this.service.getDisciplinaTipo()
            .then(response => {
                this.tipos = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.turma = ""; 
        this.tipo_id = null;
        this.status_id = null;
        this.cpfInstrutor = "";
        this.cargaHorariaMin = null;
        this.cargaHorariaMax = null;
        this.isSomatorio = null;
        this.refreshTable();
    }

    created() {
        this.service = new DisciplinaService();
        this.getDisciplinaTipo();
        this.getStatus();
        this.config.order = [[3, "desc"],[1, "asc"]];
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => { 
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    turma: this.turma, 
                    tipo: this.tipo_id,
                    status: this.status_id,
                    cpfInstrutor: this.cpfInstrutor,
                    cargaHorariaMin: this.cargaHorariaMin,
                    cargaHorariaMax: this.cargaHorariaMax,
                    isSomatorio: this.isSomatorio,
                    search: this.search || d.search.value, 
                };
                return dados;
            }
        };

        this.config.columns = [
            { data: "id", name: "id" },
            { data: "descricao", name: "descricao" },
            { data: "turma.descricao", name: "turma" },
            { data: "turma.descricao", name: "turmainicio",class: "never" },
            { data: "cargaHoraria", name: "cargahoraria" },
            { data: "tipo.nome", name: "tipo" },
            { data: "peso", name: "peso" },
        ];

        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs = [
                {
                    targets: 7,
                    render: (row, type, val) => {
                        let texto = "";
                        let buttom = "";
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';
                        return texto;
                    },
                },
            ];
        }
    }

    public tableatualizada() {
        $("[btn-show]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            this.$router.push({ name: "sigap_disciplina_show", params: { id: id } });
        });
    }
}
